export default "__VITE_ASSET__BhO6zEH0__"